import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, Validators as val } from "@angular/forms";

import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject } from 'rxjs';
import paymentOptionsConstant from 'src/app/shared/paymentOptionsConstant';
import { BaseForm } from 'src/app/shared/product/baseForm';
import { FormValidatorService } from '../../../../../../../shared/services/form-validator.service';
import { Validators } from '../../../../../../../shared/validators';
import { PaymentMethodsService } from '../../services/payment-methods.service';
import { ProviderAddService } from '../../services/provider-add.service';
import { ProviderEditService } from '../../services/provider-edit.service';
import { ProviderGetService } from '../../services/provider-get.service';

@Component({
  selector: 'app-manage-provider',
  templateUrl: './manage-provider.component.html',
  styleUrls: ['./manage-provider.component.scss']
})
export class ManageProviderComponent extends BaseForm implements OnInit {

  errorMessage;
  providerForm: FormGroup;
  loading = false;
  providerForm$: Observable<boolean>;
  private unsubscribe: Subject<any>; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
  isCreate;
  id;

  payment_methods = [];
  payment_config:Array<{name:string,value:string}> = []

  constructor(
    private cdr: ChangeDetectorRef,
    public formValidator: FormValidatorService,
    private translate: TranslateService,
    private paymentMethodsService: PaymentMethodsService,
    private activeRoute: ActivatedRoute,
    private getProvider: ProviderGetService,
    private editProviderServ: ProviderEditService,
    private addProviderServ: ProviderAddService,
    private router: Router
  ) {
    super();
    this.unsubscribe = new Subject();
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.loading = false;
  }

  async ngOnInit() {
    try {
      await this.getPaymentMethods();
      this.activeRoute.paramMap.subscribe(async (paramMap: ParamMap) => {
        this.id = parseInt(paramMap.get("id"));
        if (this.id) {
          this.getProvider.setParams({ id: this.id });
          let res = await this.getProvider.make();
          const data = res.provider;
          this.initForm();
          this.providerForm.patchValue({ ...data});
          this.payment_config = data.configs;
          this.cdr.detectChanges();
        } else {
          this.isCreate = true;
          this.initForm();
        }


      })
    } catch (err) {
      console.log(err);
    }
  }

  async getPaymentMethods() {
    this.paymentMethodsService.setParams({});
    let responsData = await this.paymentMethodsService.make();
    this.payment_methods = responsData.paymentOptions;

  }

  paymentOptionChange(event) {
    if (!event) return;
    for(let option of this.payment_methods){
      if(option.id == event.value){
        //this will remove old values
        //TODO: handle old values
        this.payment_config = [];
        for(let config of option.configs){
          this.payment_config.push({name:config,value:""});
        }
      }
    }
    this.cdr.detectChanges()
  }
  initForm() {
    this.providerForm = this.formValidator.createForm([
      {
        fieldName: "name",
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: this.translate.instant("FORMS.VALIDATION.REQUIRED", {
              field: "name"
            })
          },
        ]
      },
      {
        fieldName: "flatRate",
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: this.translate.instant("FORMS.VALIDATION.REQUIRED", {
              field: "flatRate"
            })
          },

        ]
      },
      {
        fieldName: "OffUsRate",
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: this.translate.instant("FORMS.VALIDATION.REQUIRED", {
              field: "OffUsRate"
            })
          },
        ]
      },
      {
        fieldName: "OnUSRate",
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: this.translate.instant("FORMS.VALIDATION.REQUIRED", {
              field: "OnUSRate"
            })
          }
        ]
      },
      {
        fieldName: "paymentOptionId",
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: this.translate.instant("FORMS.VALIDATION.REQUIRED", {
              field: "paymentOptionId"
            })
          }
        ]
      },
    ]);

  }
  
  async saveProvider(event) {
    event.preventDefault();
    if (this.providerForm.invalid) { this.formValidator.forceShowErrors(); return; }
    if (!this.isCreate) {
      await this.editProvider();
    } else {
      await this.addProvider();
    }
  }
  async editProvider() {
    this.editProviderServ.setParams({ ...this.providerForm.value, id: this.id ,configs:this.payment_config});
    let res = await this.editProviderServ.make();
    if (res.success) {
      this.router.navigate(['admin/providers']);
    } else {
      this.errorMessage = res.message;
    }
  }
  async addProvider() {
    this.addProviderServ.setParams({...this.providerForm.value,configs:this.payment_config});
    let res = await this.addProviderServ.make();
    if (res.success) {
      this.router.navigate(['admin/providers'])
    } else {
      this.errorMessage = res.message;
      this.cdr.detectChanges()
    }
  }

}
